import { Flex, FlexProps } from "@chakra-ui/react";
import { InputControl, InputControlProps } from "formik-chakra-ui";

export type NameFormProps = {
  firstName?: { label?: string };
  middleName?: { label?: string };
  lastName?: { label?: string };
  firstNameProps?: Partial<InputControlProps>;
  middleNameProps?: Partial<InputControlProps>;
  lastNameProps?: Partial<InputControlProps>;
} & FlexProps;
export const NameForm: React.FC<NameFormProps> = ({
  firstName,
  middleName,
  lastName,
  firstNameProps,
  middleNameProps,
  lastNameProps,
  ...props
}) => {
  return (
    <Flex direction="column" gap={4} {...props}>
      <InputControl
        inputProps={{ placeholder: "E.g.: Alex" }}
        name="first_name"
        id="first_name"
        label={firstName?.label ?? "First name"}
        isRequired={true}
        labelProps={{ requiredIndicator: <></> }}
        {...firstNameProps}
      />
      <InputControl
        isRequired={false}
        inputProps={{ placeholder: "E.g.: Dan" }}
        name="middle_name"
        id="middle_name"
        label={`${middleName?.label ?? "Middle name"} (Optional)`}
        {...middleNameProps}
      />
      <InputControl
        inputProps={{ placeholder: "E.g.: Doe" }}
        name="last_name"
        id="last_name"
        label={lastName?.label ?? "Last name"}
        isRequired={true}
        labelProps={{ requiredIndicator: <></> }}
        {...lastNameProps}
      />
    </Flex>
  );
};
